import { Image } from '@accedo/ctv-image';
import { FunctionalComponent } from 'preact';
import { stylesheet } from 'astroturf';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .card-container {
    display: flex;
    flex-direction: column;
    margin-right: pxToVw(20);
    border-radius: 100%;
    width: pxToVw(164);
    flex-shrink: 0;
  }

  .circular-image {
    background-color: $primary-grey-30;
    object-fit: cover;
    border-radius: 100%;
  }

  .extras-number {
    margin-top: pxToVh(18);
    font-size: pxToVw(18);
    text-align: center;
    visibility: hidden;
  }

  :global(.current-focus) .extras-number{
    visibility: visible;
  }


  :global(.current-focus) .circular-image {
    border: $pure-white solid 2px;
    border-radius: 100%;
    transform: scale(1.1, 1.1);
  }
`;

type PosterProps = {
  imageUrl: string;
};

const ExtrasCarouselTile: FunctionalComponent<PosterProps & {
  isInbound: boolean;
  domId: string;
  numberOfExtras: number;
}> = ({ imageUrl, isInbound, domId, numberOfExtras }) => {
  const fallbackUrl = '/assets/placeholders/Fallback-ExtrasLogo.png';
  return (
    <div className={styles.cardContainer} id={domId}>
      {isInbound ? (
        <>
          <Image
            className={styles.circularImage}
            url={
              imageUrl ? `${imageUrl}?image-profile=foxtel_extras` : fallbackUrl
            }
            fallbackUrl={fallbackUrl}
            width={164}
            height={164}
          />
          <div className={styles.extrasNumber}>{numberOfExtras} Extras</div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ExtrasCarouselTile;
